import { Reducer } from 'interfaces'
import { CurrenciesMetaReducer, CurrenciesMetaReducerCurrencyItem } from 'components/features/rewards/rewardsPane/types/store'
import {
  CurrenciesMetaGetMetaInfoRequestAction,
  CurrenciesMetaReducerChangeStateAction,
  CurrenciesMetaReducerUpsertMetaStateAction,
} from 'components/features/rewards/rewardsPane/store/actions/currenciesMeta'
import { concatCollections, normalize } from 'helpers/normalizeHelpers'

const CURRENCIES_META_REDUCER_DEFAULT_STATE: CurrenciesMetaReducer = {}


export const currenciesMetaReducer: Reducer<CurrenciesMetaReducer> = (
  prevState: CurrenciesMetaReducer = CURRENCIES_META_REDUCER_DEFAULT_STATE,
  action,
): CurrenciesMetaReducer => {
  switch (action.type) {
    case CurrenciesMetaReducerChangeStateAction.type:
      return {
        ...prevState,
        ...action.payload,
      }
    case CurrenciesMetaReducerUpsertMetaStateAction.type:
      return {
        ...prevState,
        currenciesMeta: prevState.currenciesMeta && action.payload
          ? concatCollections(prevState.currenciesMeta, action.payload)
          : action.payload,
      }
    case CurrenciesMetaGetMetaInfoRequestAction.type: {
      if (action.meta === 'request') {
        return {
          ...prevState,
          isLoading: true,
        }
      }
      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          error: action.payload,
        }
      }

      if (!action.payload.response) {
        return {
          ...prevState,
          isLoading: false,
        }
      }
      return {
        ...prevState,
        isLoading: false,
        lastUpdateDate: new Date(),
        currenciesMeta: (
          normalize(action.payload.response.map((currencyItemMeta): CurrenciesMetaReducerCurrencyItem => {
            return {
              id: currencyItemMeta.ticker,
              name: currencyItemMeta.name,
              // TODO - is it necessary to use the full format
              icon: currencyItemMeta.icon.sources[0].url,
              abbreviation: currencyItemMeta.ticker,
              isAllowedToBuy: currencyItemMeta.can_be_invested,
              isDefault: Boolean(currencyItemMeta.is_default),
              minAmount: currencyItemMeta.min_amount ? parseFloat(currencyItemMeta.min_amount) : 0.01,
            }
          }), 'id')
        ),
      }
    }
    default:
      return prevState
  }
}
